module.exports = __webpack_public_path__ + "static/media/website-sales.4675999d.png";